import { useContext, useEffect, useState } from 'react';
import { Subscription } from 'rxjs';

import { SocketContext } from '../providers/SocketProvider/SocketProvider';
import { newRelicNoticeError } from './useNewRelic';

const POOR_LATENCY_TRESHOLD = 400; // 400 ms is considered poor latency and we should show the notification

export function useLatency() {
  const { gameAPI } = useContext(SocketContext);
  const [latency, setLatency] = useState<number>(0);
  const [hasPoorLatency, setHasPoorLatency] = useState<boolean>(false);

  useEffect(() => {
    let $sub: Subscription | undefined = undefined;
    if (gameAPI) {
      $sub = gameAPI.$latency().subscribe({
        next: val => {
          setLatency(val);
          if (val >= POOR_LATENCY_TRESHOLD) {
            setHasPoorLatency(true);
          } else {
            setHasPoorLatency(false);
          }
        },
        error: error => {
          newRelicNoticeError(error, 'Error finding latency');
        },
      });
    }
    return () => {
      if ($sub) {
        $sub.unsubscribe();
      }
    };
  }, [gameAPI]);

  return {
    latency,
    hasPoorLatency,
  };
}
